import { render, staticRenderFns } from "./audioInfo.vue?vue&type=template&id=cd6766f8&scoped=true"
import script from "./audioInfo.vue?vue&type=script&lang=js"
export * from "./audioInfo.vue?vue&type=script&lang=js"
import style0 from "./audioInfo.vue?vue&type=style&index=0&id=cd6766f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6766f8",
  null
  
)

export default component.exports